module.exports = __webpack_public_path__ + "img/10.5dedd5f7.jpg";